<div class="p-2 w-100">
  
    <!-- Header minimalista -->
    <div class="uncp-header text-white p-4 mb-4">
        <div class="d-flex justify-content-between align-items-center">
        <div>
            <h3 class="mb-1 fw-light">
            <i class="fas fa-truck me-2"></i>
            Administración de Proveedores
            </h3>
        </div>
        <button class="btn btn-light uncp-btn" data-bs-toggle="modal" data-bs-target="#modalAdd">
            <i class="fas fa-plus me-1"></i>
            Nuevo Proveedor
        </button>
        </div>
    </div>

    <!-- Estadísticas rápidas -->
    <div class="row mx-0 mb-4">
        <div class="col-md-3">
            <div class="card border-0 shadow-sm">
                <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-building text-primary fs-4 me-3"></i>
                            <div>
                                <h6 class="mb-0 fw-bold">Total</h6>
                                <span class="text-muted small">Proveedores</span>
                            </div>
                        </div>
                        <span class="badge bg-primary fs-5 px-3 py-2">150</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card border-0 shadow-sm">
                <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-check-circle text-success fs-4 me-3"></i>
                            <div>
                                <h6 class="mb-0 fw-bold">Activos</h6>
                                <span class="text-muted small">Habilitados</span>
                            </div>
                        </div>
                        <span class="badge bg-success fs-5 px-3 py-2">142</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card border-0 shadow-sm">
                <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-pause-circle text-warning fs-4 me-3"></i>
                            <div>
                                <h6 class="mb-0 fw-bold">Suspendidos</h6>
                                <span class="text-muted small">Temporalmente</span>
                            </div>
                        </div>
                        <span class="badge bg-warning fs-5 px-3 py-2">5</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card border-0 shadow-sm">
                <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-times-circle text-danger fs-4 me-3"></i>
                            <div>
                                <h6 class="mb-0 fw-bold">Inactivos</h6>
                                <span class="text-muted small">Deshabilitados</span>
                            </div>
                        </div>
                        <span class="badge bg-danger fs-5 px-3 py-2">3</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Controles de búsqueda y filtros -->
    <div class="row mx-0 mb-3 align-items-center">
        <div class="col-md-4 px-1">
            <div class="input-group">
                <span class="input-group-text"><i class="fas fa-search"></i></span>
                <input type="text" class="form-control" placeholder="Buscar por nombre o RUC...">
            </div>
        </div>
        <div class="col-md-3 px-1 mt-2 mt-md-0">
            <select class="form-select">
                <option value="">Todos los estados</option>
                <option value="1">Activos</option>
                <option value="2">Suspendidos</option>
                <option value="0">Inactivos</option>
            </select>
        </div>
        <div class="col-md-3 px-1 mt-2 mt-md-0">
            <select class="form-select">
                <option value="">Todas las categorías</option>
                <option value="servicios">Servicios</option>
                <option value="productos">Productos</option>
                <option value="construccion">Construcción</option>
                <option value="tecnologia">Tecnología</option>
                <option value="consultoria">Consultoría</option>
            </select>
        </div>
        <div class="col-md-2 px-1 text-md-end mt-2 mt-md-0">
            <div class="d-flex align-items-center justify-content-md-end">
                <span class="me-2 small text-muted">Mostrar:</span>
                <select class="form-select form-select-sm w-auto">
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </div>
        </div>
    </div>

    <!-- Tabla -->
    <div class="card uncp-card">
        <div class="table-responsive">
            <table class="table table-hover uncp-table mb-0">
                <thead>
                    <tr>
                        <th style="min-width: 15px;">#</th>
                        <th>Proveedor</th>
                        <th class="d-none d-lg-table-cell">RUC</th>
                        <th class="d-none d-md-table-cell">Contacto</th>
                        <th>Categoría</th>
                        <th class="text-center">Estado</th>
                        <th class="text-center" style="width: 120px;">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Loading -->
                    <tr class="d-none">
                        <td colspan="7" class="text-center py-4">
                            <div class="spinner-border text-uncp" role="status"></div>
                            <div class="mt-2">Cargando...</div>
                        </td>
                    </tr>
                    <!-- Datos de ejemplo -->
                    <tr>
                        <td class="text-muted small">1</td>
                        <td>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-building text-uncp me-2 fa-lg"></i>
                            </div>
                            <div class="fw-medium">Constructora del Centro SAC
                                <small class="text-muted d-md-none">constructora centro.com</small>
                            </div>
                        </td>
                        <td class="d-none d-lg-table-cell">
                            <span class="badge bg-light text-dark">20512345678</span>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <div>
                                <div class="small">constructora&#64;centro.com</div>
                                <div class="small text-muted">964-123-456</div>
                            </div>
                        </td>
                        <td>
                            <span class="badge bg-info">Construcción</span>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-success">Activo</span>
                        </td>
                        <td class="text-center">
                            <div class="btn-group btn-group-sm">
                                <button class="btn btn-outline-primary" title="Editar" data-bs-toggle="modal" data-bs-target="#modalAdd">
                                <i class="fas fa-edit"></i>
                                </button>
                                <button class="btn btn-outline-info" title="Ver detalles" data-bs-toggle="modal" data-bs-target="#modalDetalles">
                                <i class="fas fa-eye"></i>
                                </button>
                                <button class="btn btn-outline-danger" title="Eliminar" data-bs-toggle="modal" data-bs-target="#modalEliminar">
                                <i class="fas fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-muted small">2</td>
                        <td>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-building text-uncp me-2 fa-lg"></i>
                                <div>
                                <div class="fw-medium">TechSolutions EIRL</div>
                                <small class="text-muted d-md-none">info&#64;techsolutions.pe</small>
                                </div>
                            </div>
                        </td>
                        <td class="d-none d-lg-table-cell">
                            <span class="badge bg-light text-dark">20598765432</span>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <div>
                                <div class="small">info&#64;techsolutions.pe</div>
                                <div class="small text-muted">987-654-321</div>
                            </div>
                        </td>
                        <td>
                            <span class="badge bg-primary">Tecnología</span>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-success">Activo</span>
                        </td>
                        <td class="text-center">
                            <div class="btn-group btn-group-sm">
                                <button class="btn btn-outline-primary" title="Editar" data-bs-toggle="modal" data-bs-target="#modalAdd">
                                <i class="fas fa-edit"></i>
                                </button>
                                <button class="btn btn-outline-info" title="Ver detalles" data-bs-toggle="modal" data-bs-target="#modalDetalles">
                                <i class="fas fa-eye"></i>
                                </button>
                                <button class="btn btn-outline-danger" title="Eliminar" data-bs-toggle="modal" data-bs-target="#modalEliminar">
                                <i class="fas fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-muted small">3</td>
                        <td>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-building text-uncp me-2 fa-lg"></i>
                                <div>
                                <div class="fw-medium">Servicios Generales Huancayo</div>
                                <small class="text-muted d-md-none">servicios&#64;huancayo.com</small>
                                </div>
                            </div>
                        </td>
                        <td class="d-none d-lg-table-cell">
                            <span class="badge bg-light text-dark">20445566778</span>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <div>
                                <div class="small">servicios&#64;huancayo.com</div>
                                <div class="small text-muted">964-789-123</div>
                            </div>
                        </td>
                        <td>
                            <span class="badge bg-secondary">Servicios</span>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-warning">Suspendido</span>
                        </td>
                        <td class="text-center">
                            <div class="btn-group btn-group-sm">
                                <button class="btn btn-outline-primary" title="Editar" data-bs-toggle="modal" data-bs-target="#modalAdd">
                                <i class="fas fa-edit"></i>
                                </button>
                                <button class="btn btn-outline-info" title="Ver detalles" data-bs-toggle="modal" data-bs-target="#modalDetalles">
                                <i class="fas fa-eye"></i>
                                </button>
                                <button class="btn btn-outline-danger" title="Eliminar" data-bs-toggle="modal" data-bs-target="#modalEliminar">
                                <i class="fas fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Paginación -->
    <div class="d-flex justify-content-between align-items-center mt-3">
        <div class="text-muted small">
            Mostrando 1 a 20 de 150 registros
        </div>
        <nav>
            <ul class="pagination pagination-sm mb-0">
                <li class="page-item disabled">
                <a class="page-link" style="cursor:pointer;">
                    <i class="fas fa-angle-double-left"></i>
                </a>
                </li>
                <li class="page-item disabled">
                <a class="page-link" style="cursor:pointer;">
                    <i class="fas fa-chevron-left"></i>
                </a>
                </li>
                <li class="page-item active">
                <a class="page-link" style="cursor:pointer;">1</a>
                </li>
                <li class="page-item">
                <a class="page-link" style="cursor:pointer;">2</a>
                </li>
                <li class="page-item">
                <a class="page-link" style="cursor:pointer;">3</a>
                </li>
                <li class="page-item">
                <a class="page-link" style="cursor:pointer;">
                    <i class="fas fa-chevron-right"></i>
                </a>
                </li>
                <li class="page-item">
                <a class="page-link" style="cursor:pointer;">
                    <i class="fas fa-angle-double-right"></i>
                </a>
                </li>
            </ul>
        </nav>
    </div>

</div>

<!-- Modal Crear/Editar -->
<div class="modal fade" id="modalAdd" tabindex="-1" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header bg-uncp text-white">
                <h5 class="modal-title">
                <i class="fas fa-truck me-2"></i>
                Nuevo Proveedor
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            
            <form novalidate>
                <div class="modal-body p-4">
                    <div class="row">
                        <!-- Información básica -->
                        <div class="col-12">
                            <h6 class="text-uncp mb-3">
                                <i class="fas fa-info-circle me-2"></i>
                                Información Básica
                            </h6>
                        </div>
                        
                        <!-- Razón Social -->
                        <div class="col-md-8 mb-3">
                            <label class="form-label">Razón Social <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" placeholder="Nombre completo de la empresa">
                        </div>
                        
                        <!-- RUC -->
                        <div class="col-md-4 mb-3">
                            <label class="form-label">RUC <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" placeholder="20XXXXXXXXX" maxlength="11">
                        </div>
                        
                        <!-- Nombre Comercial -->
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Nombre Comercial</label>
                            <input type="text" class="form-control" placeholder="Nombre comercial">
                        </div>
                        
                        <!-- Categoría -->
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Categoría <span class="text-danger">*</span></label>
                            <select class="form-select">
                                <option value="" disabled selected>Seleccionar categoría</option>
                                <option value="servicios">Servicios</option>
                                <option value="productos">Productos</option>
                                <option value="construccion">Construcción</option>
                                <option value="tecnologia">Tecnología</option>
                                <option value="consultoria">Consultoría</option>
                            </select>
                        </div>
                        
                        <!-- Separador -->
                        <div class="col-12"><hr class="my-3"></div>
                        <div class="col-12">
                            <h6 class="text-uncp mb-3">
                                <i class="fas fa-map-marker-alt me-2"></i>
                                Información de Contacto
                            </h6>
                        </div>
                        
                        <!-- Dirección -->
                        <div class="col-12 mb-3">
                            <label class="form-label">Dirección</label>
                            <textarea class="form-control" rows="2" placeholder="Dirección completa"></textarea>
                        </div>
                        
                        <!-- Teléfono -->
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Teléfono</label>
                            <input type="tel" class="form-control" placeholder="064-123456">
                        </div>
                        
                        <!-- Celular -->
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Celular</label>
                            <input type="tel" class="form-control" placeholder="987-654-321">
                        </div>
                        
                        <!-- Email -->
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Email <span class="text-danger">*</span></label>
                            <input type="email" class="form-control" placeholder="contacto&#64;empresa.com">
                        </div>
                        
                        <!-- Persona de Contacto -->
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Persona de Contacto</label>
                            <input type="text" class="form-control" placeholder="Nombre del contacto principal">
                        </div>
                        
                        <!-- Separador -->
                        <div class="col-12"><hr class="my-3"></div>
                        <div class="col-12">
                            <h6 class="text-uncp mb-3">
                                <i class="fas fa-cog me-2"></i>
                                Configuración
                            </h6>
                        </div>
                        
                        <!-- Estado -->
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Estado <span class="text-danger">*</span></label>
                            <select class="form-select">
                                <option value="1" selected>Activo</option>
                                <option value="2">Suspendido</option>
                                <option value="0">Inactivo</option>
                            </select>
                        </div>
                        
                        <!-- Observaciones -->
                        <div class="col-12 mb-3">
                            <label class="form-label">Observaciones</label>
                            <textarea class="form-control" rows="3" placeholder="Notas adicionales sobre el proveedor"></textarea>
                        </div>
                    </div>
                </div>
                
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        Cancelar
                    </button>
                    <button type="submit" class="btn btn-primary">
                        <i class="fas fa-save me-1"></i>
                        Guardar Proveedor
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Modal Ver Detalles -->
<div class="modal fade" id="modalDetalles" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header bg-info text-white">
                <h5 class="modal-title">
                <i class="fas fa-eye me-2"></i>
                Detalles del Proveedor
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body p-4">
                <div class="row">
                    <!-- Información principal -->
                    <div class="col-md-8">
                        <h4 class="text-uncp mb-1">Constructora del Centro SAC</h4>
                        <p class="text-muted mb-3">Construcción</p>
                        
                        <div class="row mb-3">
                            <div class="col-sm-4"><strong>RUC:</strong></div>
                            <div class="col-sm-8">20512345678</div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-4"><strong>Email:</strong></div>
                            <div class="col-sm-8">constructora centro.com</div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-4"><strong>Teléfono:</strong></div>
                            <div class="col-sm-8">064-123456</div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-4"><strong>Celular:</strong></div>
                            <div class="col-sm-8">964-123-456</div>
                        </div>
                    </div>
                    
                    <!-- Estado y estadísticas -->
                    <div class="col-md-4">
                        <div class="card bg-light">
                            <div class="card-body text-center">
                                <i class="fas fa-check-circle text-success fa-3x mb-2"></i>
                                <h5 class="text-success">ACTIVO</h5>
                                <small class="text-muted">Estado actual</small>
                            </div>
                        </div>
                        
                        <div class="mt-3">
                            <h6 class="text-uncp">Estadísticas</h6>
                            <div class="d-flex justify-content-between mb-2">
                                <span>Contratos:</span>
                                <span class="badge bg-primary">12</span>
                            </div>
                            <div class="d-flex justify-content-between mb-2">
                                <span>Activos:</span>
                                <span class="badge bg-success">8</span>
                            </div>
                            <div class="d-flex justify-content-between">
                                <span>Finalizados:</span>
                                <span class="badge bg-secondary">4</span>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Dirección -->
                    <div class="col-12 mt-3">
                        <h6 class="text-uncp">
                            <i class="fas fa-map-marker-alt me-2"></i>
                            Dirección
                        </h6>
                        <p class="text-muted">Av. Real 123, El Tambo, Huancayo, Junín</p>
                    </div>
                    
                    <!-- Observaciones -->
                    <div class="col-12 mt-3">
                        <h6 class="text-uncp">
                            <i class="fas fa-sticky-note me-2"></i>
                            Observaciones
                        </h6>
                        <p class="text-muted">Proveedor especializado en construcción de infraestructura educativa. Cuenta con experiencia en proyectos universitarios.</p>
                    </div>
                    
                    <!-- Fechas -->
                    <div class="col-12 mt-3">
                        <div class="row">
                            <div class="col-md-6">
                                <h6 class="text-uncp small">Fecha de Registro</h6>
                                <p class="text-muted">15/03/2024 - 10:30 AM</p>
                            </div>
                            <div class="col-md-6">
                                <h6 class="text-uncp small">Última Actualización</h6>
                                <p class="text-muted">28/09/2024 - 02:15 PM</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#modalAdd">
                    <i class="fas fa-edit me-1"></i>
                    Editar
                </button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal Eliminar -->
<div class="modal fade" id="modalEliminar" data-bs-backdrop="static" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header bg-danger text-white">
                <h6 class="modal-title">
                <i class="fas fa-trash me-2"></i>
                Confirmar Eliminación
                </h6>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div class="text-center">
                <i class="fas fa-exclamation-triangle text-warning fa-2x mb-3"></i>
                <p>¿Eliminar el proveedor <strong>Constructora del Centro SAC</strong>?</p>
                <small class="text-muted">Esta acción no se puede deshacer.</small>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                Cancelar
                </button>
                <button type="button" class="btn btn-danger">
                <i class="fas fa-trash me-1"></i>
                Eliminar
                </button>
            </div>
        </div>
    </div>
</div>
